/**
 * Сравнение названий без учёта регистра, пробелов и «ё/е» (БЛ M2 5.4) —
 * то же правило, что normalizeText на сервере. Только для подсказки
 * «похоже на дубль» в форме; решение принимает сервер.
 */
export function normalizeName(value: string): string {
  return value.toLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();
}

/** «ПJ» для «Пульс Junior» — аватар студии и команды, как iniS() в макете. */
export function titleInitials(title: string): string {
  return title
    .split(/[\s-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0))
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
